import { BaggageKeys, BaggageValue, normalizeBaggageValue } from '../baggageKeys';
import { FULLSTORY_SESSION_KEYS, getFullStorySessionEntries } from '../fullstory/fullStorySession';

type BaggageState = Partial<Record<BaggageKeys, string>>;

let state: BaggageState = {};

/**
 * Sets (or clears, with any absent-equivalent value) one baggage key.
 */
export function setBaggageValue(key: BaggageKeys, value: BaggageValue): void {
  state = { ...state, [key]: normalizeBaggageValue(value) };
}

/**
 * Flattens current state into the baggage keyset. FullStory session keys are resolved
 * per-request so ui_rum_session_ts reflects the user's position at request time.
 */
export function getBaggageEntries(): Record<string, string> {
  const entries: Record<string, string> = {};

  // Iterate the enum to build the emit list
  for (const key of Object.values(BaggageKeys)) {
    if (FULLSTORY_SESSION_KEYS.includes(key)) continue;
    const value = state[key];
    if (value) entries[key] = value;
  }

  // Session keys are resolved per request
  Object.assign(entries, getFullStorySessionEntries());

  return entries;
}
